export default __webpack_public_path__ + "static/media/Oneceptron_Logo_SVG_v3.60d38fb6.svg";